import React,{useEffect, useState} from "react";
import { Link, useParams,useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Form, Button, Label } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import ReactPlayer from 'react-player/lazy';
import useConfirm from "../../customHooks/useConfirm";
import {useFetchApi} from "../../customHooks/useFetch";
import { HTTPURL, REQUEST_OPTIONS, REQUEST_OPTIONS_NO_HEAD } from "../../constants/matcher";

const EditAssignment = () => 
{
    const [reqData, setreqData] = useState({}); // <-- add state
    const { resData } = useFetchApi(reqData); // <-- pass location value to hook
    const {confirm} = useConfirm();
    const [showImg, setShowImg] = useState(false);
    const [image, setImage] = useState({ preview: '', data: '' });
    const [pdf, setPdf] = useState({ preview: '', data: '' });
    const [video, setVideo] = useState({ preview: '', data: '' });
    const [lessAssgn, setlessAssgn] = useState({ preview: '', data: '' });
    let images = [];
    let files = [];
    let pdfName = [];
    let pdfFile = [];
    let videoName = [];
    let VideoFile = [];
    let lessonAssign = [];
    const navigate = useNavigate();
    
    const {
        register,
        getValues,
        setValue,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const {assignment_id} = useParams();

    useEffect(() => 
    {
        const fetchData = async() =>
        {
            return await fetch(HTTPURL+'admin/edit-assignment/'+assignment_id)
            .then((response) => response.json())
            .then((data) => 
            {
                setImage({preview: data.imageArray,data:''});
                setPdf({preview: data.pdfArray,data:''});
                setVideo({preview: data.videoArray,data:''});
                setlessAssgn({preview: data.lessonArray,data:''});
                setValue('courseName',data.data[0].course);
                setValue('lesson_name',data.data[0].lesson_name);
            });
        }
        fetchData();
    },[resData]);
    // code for images changes
    const handleFileChange = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            images.push(URL.createObjectURL(e.target.files[i]));
            files.push(e.target.files[i]);
        }
        setImage({preview: images,data:files});
        setShowImg(true);
    }

    // code for pdf handler changes
    const pdfHandleFile = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            pdfName.push(URL.createObjectURL(e.target.files[i]));
            pdfFile.push(e.target.files[i]);
        }
        setPdf({preview: pdfName,data:pdfFile});
        setShowImg(true);
    }

    // code for video handler changes
    const videoHandleFile = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            videoName.push(URL.createObjectURL(e.target.files[i]));
            VideoFile.push(e.target.files[i]);
        }
        setVideo({preview: videoName,data:VideoFile});
        setShowImg(true);
    }

    // code for video handler changes
    const lessonAssHandleFile = (e) => 
    {
        for (let i = 0; i < e.target.files.length; i++) 
        {
            lessonAssign.push(e.target.files[i]);
        }
        setlessAssgn({preview: '',data:lessonAssign});
        setShowImg(true);
    }

    // remove array images 
    const showImageConfirm = async (id) => {
        const isConfirmed = await confirm('Do you confirm your choice?');

        if (isConfirmed) {
            console.log('Confirmed!')
            removeImageHandle(id);
        } else {
            console.log('Declined.')
        }
    }

    const removeImageHandle = (requestData) =>
    {
        requestData = {
            'link' : 'admin/destroy-image-assignment/'+requestData,
            'token' : 'required',
        };
        setreqData(requestData);
    }

    // remove aarray pdf
    const showPdfConfirm = async (id) => {
        const isConfirmed = await confirm('Do you confirm your choice?');

        if (isConfirmed) {
            console.log('Confirmed!')
            removePdfHandle(id);
        } else {
            console.log('Declined.')
        }
    }

    const removePdfHandle = (requestData) =>
    {
        requestData = {
            'link' : 'admin/destroy-pdf-assignment/'+requestData,
            'token' : 'required',
        };
        setreqData(requestData);
    } 

    // remove array video 
    const showVideoConfirm = async (id) => {
        const isConfirmed = await confirm('Do you confirm your choice?');

        if (isConfirmed) {
            console.log('Confirmed!')
            removeVideoHandle(id);
        } else {
            console.log('Declined.')
        }
    }

    const removeVideoHandle = (requestData) =>
    {
        requestData = {
            'link' : 'admin/destroy-video-assignment/'+requestData,
            'token' : 'required',
        };
        setreqData(requestData);
    } 

    // remove array lesson 
    const showLessonConfirm = async (id) => {
        const isConfirmed = await confirm('Do you confirm your choice?');

        if (isConfirmed) {
            console.log('Confirmed!')
            removeLessonHandle(id);
        } else {
            console.log('Declined.')
        }
    }

    const removeLessonHandle = (requestData) =>
    {
        requestData = {
            'link' : 'admin/destroy-lesson-assignment/'+requestData,
            'token' : 'required',
        };
        setreqData(requestData);
    }

    const onSubmit = () => 
    {
        let formData = new FormData()
        if(image.data.length > 0 && pdf.data.length > 0 && video.data.length > 0 && lessAssgn.data.length > 0)
        {   
            image.data.forEach(img =>
            {
                formData.append('files', img);
            });
            pdf.data.forEach(sinPdf =>
            {
                formData.append('pdf_files', sinPdf);
            });
            video.data.forEach(signVido =>
            {
                formData.append('video_files', signVido);
            });
            lessAssgn.data.forEach(lessAssg =>
            {
                formData.append('lesson_assignment', lessAssg);
            });
        }
        formData.append('courseName', getValues("courseName"));
        formData.append('lesson_name', getValues("lesson_name"));
        componentDidMount(formData);
    }

    const componentDidMount = (requestData) =>
    {
        REQUEST_OPTIONS_NO_HEAD.method = 'Put';
        REQUEST_OPTIONS_NO_HEAD.body = requestData;
        fetch(HTTPURL+'admin/update-assignment/'+assignment_id, REQUEST_OPTIONS_NO_HEAD)
        .then(async response => 
        {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
            if (!response.ok) 
            {
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            if(data.status === true)
            {
                setValue('courseName','');
                setValue('lesson_name','');
                setValue('image','');
                setValue('pdf','');
                setValue('video','');
                setValue('lesson_assignment','');
                setImage({preview: '',data:''});
                toast.success(data.message);
                navigate('/secure/assignments');

            }else{
                toast.error(data.message);
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }

    return (
        <div className="container rounded bg-white mt-5 mb-5">
                <div className="row">
                    <div className="col-md-2 border-right">
                        <div className="d-flex flex-column align-items-center text-center prf-img-set">
                            {
                                showImg ?
                                image.preview && image.preview.map((img,ind) => 
                                {
                                    return <img key={ind} src={img} className="rounded-circle mt-5" height="100px" width="100px" />;
                                })
                                :  
                                image.preview && image.preview.map((img,ind) => 
                                {
                                    return <div key={ind} className="image-show"><img src={HTTPURL+'images/'+img.name} className="rounded-circle mt-5" height="100px" width="100px" /><span className="remove-icon" onClick={() => showImageConfirm(img.id)}><i className="fa fa-remove"></i></span></div>;
                                })
                            }
                        </div>
                    </div>
                    <div className="col-md-7 border-right">
                        <div className="p-3 py-5">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="text-right">Edit Assignment</h4>
                            </div>
                            <Form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                                <div className="row mt-2">
                                    <div className="col-md-6">
                                        <Form.Field>
                                                <label className="form-label" htmlFor="course name">Course Name:</label>
                                                <select
                                                    {...register("courseName", { required: true})}
                                                >
                                                    <option className="text-center" value="">Select Course</option>
                                                    <option className="text-center" value="1">Demo 1</option>
                                                    <option className="text-center" value="2">Demo 2</option>
                                                    <option className="text-center" value="3">Demo 3</option>
                                                    <option className="text-center" value="4">Demo 4</option>
                                                    <option className="text-center" value="5">Demo 5</option>
                                                </select>
                                        </Form.Field>
                                        {errors.courseName && errors.courseName.type === "required" && <span className="validation-error">This is required</span>}
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Field>
                                                <label className="form-label" htmlFor="lesson name">Lesson Name:</label>
                                                <input
                                                    placeholder='lesson_name'
                                                    type="text"
                                                    {...register("lesson_name",{ required: true})}
                                                    className="form-control form-control-lg"
                                                />
                                            </Form.Field>
                                            {errors.lesson_name && errors.lesson_name.type === "required" && <span className="validation-error">This is required</span>}
                                        </div>
                                    </div>
                                    <hr/>
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <h6 className="form-label" htmlFor="course content">Lesson Resources:</h6>
                                        <Form.Field>
                                                <label className="form-label" htmlFor="image">Images upload:</label>
                                                <input
                                                    placeholder='image'
                                                    type="file"
                                                    {...register("image")}
                                                    className="form-control form-control-lg"
                                                    onChange={handleFileChange}
                                                    accept="image/*"
                                                    multiple
                                                />
                                                <span> File Formats: png & jpg, jpeg.</span>
                                        </Form.Field>
                                        {/* {errors.image && errors.image.type === "required" && <span className="validation-error">This is required</span>} */}
                                        <Form.Field>
                                                <label className="form-label" htmlFor="course name">Pdf:</label>
                                                <input
                                                    placeholder='Pdf'
                                                    type="file"
                                                    {...register("pdf")}
                                                    className="form-control form-control-lg"
                                                    onChange={pdfHandleFile}
                                                    accept=".pdf*"
                                                    multiple
                                                />
                                        </Form.Field>
                                        {
                                            pdf.preview && pdf.preview.map((pdf,ind) => 
                                            {
                                                return <div key={ind} className="pdf-show"><input value={HTTPURL+'pdf/'+pdf.name} readOnly/><span className="remove-icon" onClick={() => showPdfConfirm(pdf.id)}><i className="fa fa-remove"></i></span></div>;
                                            })
                                        }
                                        <Form.Field>
                                                <label className="form-label" htmlFor="Video">Video:</label>
                                                <input
                                                    placeholder='Video'
                                                    type="file"
                                                    {...register("video")}
                                                    className="form-control form-control-lg"
                                                    onChange={videoHandleFile}
                                                    accept="video/*"
                                                    multiple
                                                />
                                        </Form.Field>
                                        {
                                            video.preview && video.preview.map((vid,ind) => 
                                            {
                                                return <div key={ind} className="video-show">
                                                <ReactPlayer className='react-player' width="100%" height="100%" url={HTTPURL+'videos/'+vid.name} />
                                                <span className="remove-icon" onClick={() => showVideoConfirm(vid.id)}><i className="fa fa-remove"></i></span></div>;
                                            })
                                        }
                                    </div>
                                </div>
                                <hr/>
                                <div className="row mt-2">
                                    <div className="col-md-12">
                                        <h6 className="form-label" htmlFor="course name">Lesson Assignment:</h6>
                                        <Form.Field>
                                                <input
                                                    placeholder=''
                                                    type="file"
                                                    {...register("lesson_assignment")}
                                                    className="form-control form-control-lg"
                                                    onChange={lessonAssHandleFile}
                                                    multiple
                                                />
                                        </Form.Field>
                                        {
                                            lessAssgn.preview && lessAssgn.preview.map((lesson,ind) => 
                                            {
                                                return <div key={ind} className="pdf-show"><input value={HTTPURL+'lessonAssignment/'+lesson.name} readOnly/><span className="remove-icon" onClick={() => showLessonConfirm(lesson.id)}><i className="fa fa-remove"></i></span></div>;
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="mt-3"><button className="btn btn-primary profile-button sap-btn-dark" type="submit">Update</button></div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default EditAssignment;